module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAf0lEQVR42u3aMQ3AMAwAQVPoUhYBE1TFVxYBEclBYSmSb3gCN39kZnQuAAAAAAAAAAAAAABoDhDfzMr2/14VAAAAAAAAAAAAAAAAAAAAAAAAAAAAagHWM64KAAAAAAAAAAAAAAAAAAAAAAAAAIDuAE5RAAAAAAAAAAAAAABadQCqhthpMV+FdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Benin.png
// module id = 9ZVx
// module chunks = 0 62 63